import { Loader2 } from "lucide-react";

const CSS = `
@keyframes atlas-traces-spin{ to{ transform:rotate(360deg); } }
.atlas-traces-chip__spin{ animation:atlas-traces-spin .9s linear infinite; }
@media (prefers-reduced-motion: reduce){ .atlas-traces-chip__spin{ animation:none; } }
`;

/** Quiet status chip shown on the map while the user's GPS traces load for
 *  the first time. Centred under the top control row so it clears the
 *  search/filter pills, the legend, the zoom buttons and the mobile sheet. */
export function MapTracesLoadingChip({ top }: { top: number }) {
  return (
    <div
      style={{
        position: "absolute",
        top,
        left: 16,
        right: 16,
        display: "flex",
        justifyContent: "center",
        pointerEvents: "none",
        zIndex: 9,
      }}
    >
      <div
        role="status"
        aria-live="polite"
        className="atlas-glass"
        style={{
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          gap: 7,
          padding: "6px 12px",
          borderRadius: "var(--radius-pill)",
          boxShadow: "var(--shadow-md)",
        }}
      >
        <style>{CSS}</style>
        <Loader2
          size={14}
          className="atlas-traces-chip__spin"
          color="var(--text-muted)"
          style={{ flex: "0 0 auto" }}
          aria-hidden
        />
        <span
          style={{
            fontSize: 12.5,
            fontWeight: 600,
            color: "var(--text-secondary)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minWidth: 0,
          }}
        >
          Loading your walks
        </span>
      </div>
    </div>
  );
}
